import { ChangeDetectionStrategy, Component, inject, OnInit, output } from '@angular/core';
import { NgbCollapse } from '@ng-bootstrap/ng-bootstrap';
import Slider from 'bootstrap-slider';
import { WorkflowRunning } from '../../../nextray/Core/State';
import { CanvasService } from '../../services';
import { BaseComponent } from '../../shared';


/**
 * Component for image editing tools.
 */
@Component({
	selector: 'edit-tools',
	templateUrl: './edit-tools.component.html',
	imports: [
		NgbCollapse
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class EditToolsComponent extends BaseComponent implements OnInit {

	private readonly canvasSrv = inject(CanvasService);

	sliderChanged = output<void>();
	resetted = output<void>();

	isContrast = false;
	contrastSlider: any;
	isBrightness = false;
	brightnessSlider: any;

	private resetId?: NodeJS.Timeout;

	ngOnInit(): void {
		this.initSliders();
	}

	private initSliders(): void {
		const sliderOptions = { id: "slider12a", min: -1, max: 1, step: 0.1, value: 0, tooltip: 'hide' };
		this.brightnessSlider = new Slider("#brightnessSlider", sliderOptions).on('change', (val) => this.setBrightness(val as any));
		this.contrastSlider = new Slider("#contrastSlider", sliderOptions).on('change', (val) => this.setContrast(val as any));
		this.initSliderValues();
	}

	initBrightnessValue(): void {
		this.brightnessSlider.setValue(this.canvasSrv.brightness);
	}

	initContrastValue(): void {
		this.contrastSlider.setValue(this.canvasSrv.contrast);
	}

	initSliderValues(): void {
		this.initBrightnessValue();
		this.initContrastValue();
	}

	private setBrightness(result: { oldValue: number, newValue: number }): void {
		this.canvasSrv.dispatch('setBrightness', result.newValue);
		this.sliderChanged.emit();
	}

	private setContrast(result: { oldValue: number, newValue: number }): void {
		this.canvasSrv.dispatch('setContrast', result.newValue);
		this.sliderChanged.emit();
	}

	/**
	 * Check if rotate is active.
	 */
	get isRotate(): boolean {
		return this.canvasSrv.runningWorkflow === WorkflowRunning.rotate;
	}

	/**
	 * Start rotate workflow.
	 */
	rotate(): void {
		if (!this.isRotate) {
			this.canvasSrv.dispatch('startRotate');
		}
	}

	/**
	 * Reset edit tools data.
	 */
	reset(): void {
		this.canvasSrv.dispatch('resetImageTools');
		this.resetId && clearTimeout(this.resetId);
		this.resetId = setTimeout(() => this.initSliderValues(), 100);
		this.resetted.emit();
	}

}
